/* eslint-disable no-console */
const enableTrace = false;

// 'bind' ensures the orignal code line in console
const Logger = {
  debug: console.debug.bind(console),
  info: console.info.bind(console),
  warn: console.warn.bind(console),
  error: console.error.bind(console),
  trace: enableTrace ? console.trace.bind(console) : () => {},
};

export default Logger;
